import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import planning from "../Images/planning.jpg";
import { project_name } from "../Config/config";
import SEO from "../components/SEO";  

export default function Planning() {
  return (
    <>
      <SEO  
        title="AI CRM Planning & Strategy | EnteliPro"
        description="Develop a winning CRM strategy with EnteliPro AI CRM planning. Align sales, marketing, and customer service to build lasting customer relationships."
        keywords="CRM Planning, CRM Strategy, Customer Relationship Management, AI CRM Planning, Sales Strategy, Marketing Strategy, Customer Retention"
        canonical="https://www.entelipro.com/planning"
        ogImage="https://www.entelipro.com/static/media/planning.jpg"
      />

      <Navbar />
      {/* breadcrumbs */}
      <section className="w3l-inner-banner-main">
        <div className="about-inner inner2">
          <div className="container seen-w3">
            <ul className="breadcrumbs-custom-path">
              <li>
                <Link to="/">  
                  Home{" "}
                  <span className="fa fa-angle-right" aria-hidden="true"></span>
                </Link>
              </li>
              <li className="active">Planning</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="w3l-content-with-photo-4">
        <div className="content-with-photo4-block">
          <div className="container">
            <div className="cwp4-two row">
              <div className="col-xl-6 cwp4-image ">
                <img
                  src={planning}
                  alt="EnteliPro AI CRM Planning and Strategy Development"  
                  className="img-responsive "
                />
              </div>
              <div className="cwp4-text col-xl-6">
                <h1 className="header-name" style={{ fontSize: "2.3rem", fontWeight: "700", marginBottom: "1rem" }}>
                  AI CRM Planning & Strategy
                </h1>
                <p className="para">
                  CRM Planning is a term used to describe all activities,
                  strategies, and tools used by a company to manage the way it
                  interacts with its customer base.
                  <br /> <br />
                  The right CRM strategy can help you build solid relationships
                  with your customers and increase customer loyalty and
                  retention.
                  <br /> <br />
                  However, for it to work, your strategy must align with your
                  sales and marketing plan and your customer service department.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="w3l-recent-work-hobbies">
        <div className="recent-work ">
          <div className="container">
            <div className="left-text">
              <h3>Key Elements of AI CRM Planning</h3>
              <p className="para"> </p>
            </div>
            <p className="para">
              <h4>1. Technology</h4> We use the latest technology to develop
              CRM for our clients. Data is collected from the entire customer
              lifecycle, including marketing and sales platforms, digital
              commerce, and customer service interactions.
            </p>
            <br /> <br />
            <p className="para">
              <h4>2. Strategy</h4>
              Our CRM strategy should be based on clear goals and objectives. It
              should also align with the customer company's positioning,
              culture, vision, and values.
            </p>
            <br />
            <br />
            <p className="para">
              <h4>3. Processes</h4>
              {`${project_name}`} strategy to work, all internal and external
              processes should be customer-centric. We provide the best possible
              customer experience.
            </p>
            <br /> <br />
            <p className="para">
              <h4>4. People</h4>
              Developers focused on customer engagement.
            </p>
            <br />
            <br />
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}